/**
 * public-branding-theme: the ONE public theme read a customer page makes (CC 0315).
 *
 * Two modules need the same response: workspace-datetime (date and time format) and
 * branded-chrome (header, footer, favicon). Each used to make its own call, so a fresh
 * manage page read /v1/branding/theme twice before the session exchange. Both now ask
 * here, and the second caller gets the first caller's promise.
 *
 * Customer pages serve one workspace per host, so the read is kept for the life of the
 * page. `resetPublicBrandingTheme` exists for branded-chrome's tenant-switch clear and
 * for tests.
 */
import { getPublicBrandingTheme } from "@v0y4ge/api-client";
import { SETTINGS_OPTS } from "../shell/request-opts";

let read: Promise<unknown> | null = null;

export function readPublicBrandingTheme(): Promise<unknown> {
  if (!read) {
    const r = getPublicBrandingTheme({ ...SETTINGS_OPTS, baseUrl: "" } as never) as Promise<unknown>;
    /* A failed read is not kept: the next caller may try again. */
    read = r;
    r.catch(() => { if (read === r) read = null; });
  }
  return read;
}

export function resetPublicBrandingTheme(): void { read = null; }
